import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { closeDialog } from 'app/auth/store/actions/createNotification.actions'
import ComposeMessageFormik from 'app/main/composeMessage/ComposeMessageFormik'
import { Dialog } from '@material-ui/core'

import { useOpenCompose } from 'app/main/composeMessage/useOpenCompose'
import { isNil } from 'ramda'
import MessagespringLoading from 'app/componentV4/Loader/MessagespringLoading'
import { FormattedMessage } from 'react-intl'
import { ACTION_NEW } from 'app/constants/compose'
import { isEmptyOrNil } from 'libs/empty'

const NotificationDialog = () => {
  const dispatch = useDispatch()
  const state = useSelector(({ auth }) => auth.createNotification)

  const onCloseDialog = () => dispatch(closeDialog())

  const {
    state: { isLoading, notification, error },
    getNotificationById,
    onClearState,
  } = useOpenCompose()

  useEffect(() => {
    if (state.isOpen && state.notificationId) {
      getNotificationById({
        notificationId: state.notificationId,
        type: state.type,
      })
    } else {
      onClearState()
    }
  }, [state.isOpen])

  useEffect(() => {
    if (error) {
      dispatch(closeDialog())
    }
  }, [error, dispatch])

  return (
    <Dialog fullScreen open={state.isOpen}>
      <div className="overflow-hidden">
        {((state.notificationId && isNil(notification)) || isLoading) &&
        !error ? (
          <div className="flex h-screen">
            <div className="flex justify-center m-auto">
              <div>
                <MessagespringLoading />
                <div className="text-blue-950 mt-5">
                  <FormattedMessage id="dataTable.pagination.loading" />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <ComposeMessageFormik
            open={state.isOpen}
            notification={notification}
            isCopyMessage={
              state.action === ACTION_NEW && !isEmptyOrNil(state.notificationId)
            }
            valueFromAnotherPage={state.initialValues}
            onClose={onCloseDialog}
            onCreateSuccess={state.onCreateSuccess}
            isLoading={isLoading}
            dialogType={state.type}
          />
        )}
      </div>
    </Dialog>
  )
}

export default React.memo(NotificationDialog)
